<template>
    <div v-if="id && cid" class="bg-white grid grid-cols-1 place-content-between w-full p-3 aspect-video">
        <div class="flex flex-col flex-shrink">
            <div class="col-span-2 flex flex-shrink font-bold">{{ cliente }}</div>
            <div class="col-span-2 flex flex-shrink text-sm">{{ sottotitolo }}</div>
        </div>
        <div class="flex justify-between">
            <div class="basis-1/2 flex">
                <NextButton :disabled="!email" component="a" :href="`mailto:${email}`" variant="primary" class="basis-1/2 px-3 flex items-center justify-center"><i class="icon-paper_plane"></i></NextButton>
                <NextButton :disabled="!tel" component="a" :href="`tel:${tel}`" variant="primary" class="basis-1/2 px-3 flex items-center justify-center ml-3"><i class="icon-telefono"></i></NextButton>
            </div>
            <NextButton component="router-link" variant="outline-secondary" :to="{name:'DettaglioContatto', params:{id:id, cid:cid}}"
                         class="px-3 py-1 text-xs">Vedi</NextButton>
        </div>
    </div>
    <div v-else class="bg-next-gray-md grid grid-cols-1 place-content-between w-full p-3 aspect-video">
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ContattoCard',
    components: {NextButton},
    props: {
        cliente: String,
        sottotitolo: String,
        tel: String,
        email: String,
        id: [Number, String],
        cid: [Number, String]
    }
})
export default class ContattoCard extends Vue {
    cliente!: string
    sottotitolo!: number
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
